import {documentsService} from "@/_services";
import {localVerificationService} from "../../_services/local-verification.service";
import router from "@/router";

export default {
  getDocument({dispatch, commit}, {uuid}) {
    dispatch('alert/clear', {}, { root: true });
    return documentsService.getDocument(uuid)
      .then(
        document => {
          commit("setDocumentsData", document.data[0])
          return Promise.resolve(document.data[0])
        },
        error => {
          dispatch("alert/error", error, {root:true});
          router.push("/");
          return Promise.reject();
        }
      )
  },
  flushDocument({commit}) {
    commit("setDocumentsData", [])
  },
  getLocalVerification({dispatch, commit}, {signatureId, signatureFlowId, uuid}) {
    return localVerificationService.show(signatureId, signatureFlowId, uuid)
      .then(
        localVerification => {
          return Promise.resolve(localVerification)
        },
        () => {
          return Promise.reject();
        }
      )
  },
  sendOtp({dispatch, commit}, {signatureId, signatureFlowId, uuid, phoneNumber, recaptchaToken}) {
    return localVerificationService.sendOtp(signatureId, signatureFlowId, uuid, phoneNumber, recaptchaToken)
      .then(
        localVerification => {
          return Promise.resolve(localVerification)
        },
        error => {
          return Promise.reject(error);
        }
      )
  },
  verifyOtp({dispatch, commit}, {signatureId, signatureFlowId, uuid, otp, name, curp, latitude, longitude}) {
    return localVerificationService.verifyOtp(signatureId, signatureFlowId, uuid, otp, name, curp, latitude, longitude)
      .then(
        localVerification => {
          return Promise.resolve(localVerification)
        },
        error => {
          return Promise.reject(error);
        }
      )
  }
}
